import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, Book } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const DocLayout = ({ title, category, children }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <div className="bg-white border-b shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => navigate('/documentation')}
                className="flex items-center gap-2"
              >
                <ArrowLeft className="w-4 h-4" />
                Back to Docs
              </Button>
              <div className="hidden sm:flex items-center gap-2 text-sm text-slate-500">
                <Book className="w-4 h-4" />
                <span>{category}</span>
              </div>
            </div>
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="flex items-center gap-2"
            >
              <Home className="w-4 h-4" />
              <span className="hidden sm:inline">Home</span>
            </Button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card>
          <CardContent className="pt-8">
            {/* Title */}
            <h1 className="text-4xl font-bold text-slate-900 mb-2">{title}</h1>
            <p className="text-sm text-slate-500 mb-8">{category}</p>
            
            {/* Article Content */}
            <div className="prose prose-slate max-w-none">
              {children}
            </div>

            {/* Help Section */}
            <div className="mt-12 pt-8 border-t border-slate-200">
              <div className="bg-blue-50 rounded-lg p-6">
                <h3 className="font-semibold text-slate-900 mb-2">Need more help?</h3>
                <p className="text-slate-600 mb-4">
                  Can't find what you're looking for? Our support team is here to help.
                </p>
                <div className="flex flex-wrap gap-3">
                  <Button
                    onClick={() => navigate('/contact')}
                    size="sm"
                    className="bg-indigo-600 hover:bg-indigo-700"
                  >
                    Contact Support
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => window.location.href = 'mailto:support@theVinculum.de'}
                  >
                    Email Us
                  </Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DocLayout;
